<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="batch_id">Select Batch <span style="color: red">*</span></label>
                <select v-model="search_data.batch_id" v-validate="'required'" id="batch_id" name="batch_id"
                        class="form-control form-control-sm">
                  <option :value="''" selected>Select Batch</option>
                  <option v-for="(batch, index) in batches" :key="index" :value="batch.id">
                    {{batch.trade.desc + " | " + "Batch No: " + batch.batch_no }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please Select Batch
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4" style="padding-top: 2px;">
                <label for="start_date">Start Date <span style="color: red">*</span></label>
                <datepicker
                        v-model="search_data.start_date"
                        v-validate="'required'"
                        id="start_date"
                        name="start_date"
                        :format="customStartDate"
                        placeholder="Start Date">
                </datepicker>
                <div class="text-danger" tyle="margin-top: 0.25rem; font-size: 0.75rem;"
                     v-if="errors.has('start_date')">
                  Start date required
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4" style="padding-top: 2px;">
                <label for="end_date">End Date <span style="color: red">*</span></label>
                <datepicker
                        v-model="search_data.end_date"
                        v-validate="'required'"
                        id="end_date"
                        name="end_date"
                        :format="customEndDate"
                        placeholder="End Date">
                </datepicker>
                <div class="text-danger" v-if="errors.has('end_date')" style="margin-top: 0.25rem; font-size: 0.75rem;">
                  End date required
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-6 mt-2">
                <button class="btn btn-success btn-sm custom-search-button" @click.prevent="getVoucher">
                  Search
                </button>
              </div>
            </div>

          </form>
        </b-card>
        <b-card>



          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Trainee Name</th>
                <th>HH Number</th>
                <th>Father Name/Husband Name</th>
                <th>Mouza</th>
                <th>Attendance Date</th>
                <th>Total Present</th>
                <th>Total Absent</th>
                <th>Vat & Tax</th>
                <th>Total Amount</th>
              </tr>
              </thead>
              <tbody v-for="(trainee_voucher, index) in trainee_vouchers" :key="index">
                  <tr v-for="(trainee, index) in trainee_voucher.trainees" :key="index">
                    <td>{{ index + 1}}</td>
                    <td>{{ trainee.rep_name ? trainee.rep_name : trainee.name }}</td>
                    <td>{{ trainee.household_number }}</td>
                    <td>{{ trainee.rep_father_husband_name ? trainee.rep_father_husband_name : trainee.father_husband_name }}</td>
                    <td>{{ trainee.mouza.desc }}</td>
                    <td>
                      <span v-for="(attendance, index) in trainee.batch_attendance" :key="index">
                        <span class="badge bg-soft-success text-success" style="color: #000000">
                          {{ attendance.attendance_date }}
                        </span>&nbsp;
                      </span>
                    </td>
                    <td>{{ trainee.batch_attendance.length }}</td>
                    <td></td>
                    <td></td>
                    <td>{{ trainee.total_conveyances }}</td>
                  </tr>
              </tbody>

            </table>
          </div>

          <h5 v-if="trainee_vouchers.length === 0" class="text-center text-secondary">
            No Data Found
          </h5>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
  import appConfig from "@src/app.config";
  import Layout from "@layouts/main";
  import PageHeader from "@components/page-header";
  import http from "@state/http";
  import moment from "moment";
  import Datepicker from "vuejs-datepicker";

  export default {
    page: {
      title: "Voucher Information",
      meta: [{ name: "description", content: appConfig.description }]
    },
    components: {Layout, PageHeader, Datepicker },
    data() {
      return {
        title: "Voucher Information",
        items: [
          {
            text: "Dashboard",
            href: "/"
          },
          {
            text: "Voucher Information",
            active: true
          }
        ],
        batches: [],
        search_data: {
          batch_id: '',
          start_date: '',
          end_date: '',
        },
        trainee_vouchers: [],
        flag: false,
      };
    },

    mounted() {
      this.getBatches();
    },
    methods: {
      customStartDate(date) {
        this.start_date = moment(date).format("YYYY-MM-DD");
        return moment(date).format("YYYY-MM-DD");
      },
      customEndDate(date) {
        this.end_date = moment(date).format("YYYY-MM-DD");
        return moment(date).format("YYYY-MM-DD");
      },
      getBatches() {
        http.get("api/batch/trainee/getBatch").then(response => {
          if (!response.error) {
            this.batches = response.data.batches;
          }
        });
      },
      getVoucher() {
        this.$validator.validate().then(valid => {
          if (valid) {
            http.post("api/trainee/voucher/date-range/list", this.search_data).then(response => {
              if (!response.error) {
                this.flag = true;
                this.trainee_vouchers = response.data.trainee_vouchers;
              }
            });
          }
        });

      },
    },
  };
</script>
<style lang="scss">
  .vdp-datepicker input {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ced4da;
    height: 30px;
    padding-left: 15px;
    color: #6b757d;
  }

  .c-container {
    margin-right: 5px;
  }
  .text-success {
    color: #7d858c !important;
  }
</style>